import type { ReactNode, Ref } from 'react'
import type { ViewStyle } from 'react-native'
import { Text, View } from 'react-native'

import { Spinner } from '../../../components/ui/Spinner'

export const ASPECT_RATIO_CHANGE_THRESHOLD = 0.01
const BUFFER_SPINNER_COLOR = '#ffffff'

interface VisualMediaPlayerFrameProps {
  aspectRatio: number
  children: ReactNode
  isFullscreen?: boolean
  ref?: Ref<View>
}

export function VisualMediaPlayerFrame({
  aspectRatio,
  children,
  isFullscreen = false,
  ref,
}: VisualMediaPlayerFrameProps) {
  const fullscreenStyle = isFullscreen
    ? ({
        aspectRatio: undefined,
        flex: 1,
        height: undefined,
      } satisfies ViewStyle)
    : undefined

  return (
    <View
      ref={ref}
      className="w-full mb-5 bg-gray-100 relative overflow-hidden"
      style={[{ aspectRatio }, fullscreenStyle]}
    >
      {children}
    </View>
  )
}

interface VisualMediaPlayerErrorFallbackProps {
  aspectRatio: number
}

export function VisualMediaPlayerErrorFallback({
  aspectRatio,
}: VisualMediaPlayerErrorFallbackProps) {
  return (
    <View
      className="w-full items-center justify-center bg-gray-100"
      style={{ aspectRatio }}
    >
      <Text className="text-sm text-gray-500">Unable to load video</Text>
    </View>
  )
}

export function VisualMediaPlayerLoadingOverlay() {
  return (
    <View
      className="absolute inset-0 items-center justify-center bg-black/10"
      style={{ zIndex: 20, pointerEvents: 'none' }}
    >
      <Spinner color={BUFFER_SPINNER_COLOR} size="large" />
    </View>
  )
}
